
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LayoutColumn, Layout } from '../../types';

interface GalleryColumnExt extends LayoutColumn {
  items: number[];
}

@Component({ components: {} })
export default class GalleryLayout extends Vue {
  @Prop(Array) readonly layout!: Layout;

  @Prop(String) readonly group!: string;

  get cols(): GalleryColumnExt[] {
    const { layout } = this;
    const rowCols = Math.floor(12 / layout.length);
    const lastCol = 12 - rowCols || rowCols;
    const lastIdx = layout.length - 1;
    let index = 0;
    return layout.map((col, idx) => {
      const { slots = 1 } = col;
      return {
        cols: idx === lastIdx ? lastCol : rowCols,
        ...col,
        slots,
        items: Array(slots)
          .fill(0)
          // eslint-disable-next-line no-plusplus
          .map(() => index++),
      };
    });
  }
}
